import React from 'react';

import Money from 'components/Money';

import './styles.css';

const Totals = ({subTotal = 0, subTotalVat = 0}) => (
  <div className="Totals">
    <div className="section">
      <div className="header">Subtotal</div>
      <div className="value">
        <Money amount={subTotal} />
      </div>
    </div>
    <div className="section">
      <div className="header">VAT</div>
      <div className="value">
        <Money amount={subTotalVat} />
      </div>
    </div>
    <div className="section">
      <div className="header">Total</div>
      <div className="value">
        <Money amount={subTotal + subTotalVat} />
      </div>
    </div>
  </div>
);

export default Totals;
